import React from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';

const AdditionalInfoSection = ({ data, handleChange, isAdd = false }) => {
  return (
    <>
      <InputFields
        label="Additional Information"
        helperText=""
        name="additionalInformation"
        required={false}
        value={data['additionalInformation'] || ''}
        textFieldType="text"
        width={12}
        multiline={true}
        handleIpChange={handleChange}
      />

      {/* On Add: lat/long come from the Geolocation button — no manual fields needed.
          On Edit: show as optional read-only so existing values are visible. */}
      {!isAdd && (
        <>
          <InputFields
            label="Geolocation Latitude"
            helperText=""
            name="geolocationLatitude"
            required={false}
            value={data['geolocationLatitude'] || ''}
            textFieldType="number"
            width={6}
            handleIpChange={handleChange}
            disabled={true}
          />
          <InputFields
            label="Geolocation Longitude"
            helperText=""
            name="geolocationLongitude"
            required={false}
            value={data['geolocationLongitude'] || ''}
            textFieldType="number"
            width={6}
            handleIpChange={handleChange}
            disabled={true}
          />
        </>
      )}
    </>
  );
};

export default AdditionalInfoSection;
